<template><div><h1 id="haushalt" tabindex="-1"><a class="header-anchor" href="#haushalt"><span>Haushalt</span></a></h1>
<p>Haushalt — Zeigt die Haushaltsverbindungen zur ausgewählten Adresse</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Definiert Haushaltsbeziehungen zwischen Haushaltsadressen. Dies wird v.a. bei Mailingaktionen dazu verwendet, damit nicht ein Haushalt das gleiche Mailing mehrfach zugestellt bekommt. Somit können statt alle Mitglieder des Haushaltes nur jeweils ein Mitglied angeschrieben werden. Nebst den aktuellen Haushaltsbeziehungen werden auch die früheren nicht mehr aktuellen Haushaltsbeziehungen aufgelistet (Historisierung aller Haushaltsbeziehungen).</p>
<p>Pfad: <code v-pre>Personen → Personen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>von</dt>
<dd>Datum, Beginn der Haushaltsbeziehung mit der ausgewählten Adresse</dd>
<dt>bis</dt>
<dd>Datum, Ende der Haushaltsbeziehung mit der ausgewählten Adresse</dd>
<dt>Personen-ID</dt>
<dd>Anzeige der Personen-ID des Haushaltsmitglieds</dd>
<dt>Name und Adresse</dt>
<dd>Adressdaten</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="adresse-anzeigen" tabindex="-1"><a class="header-anchor" href="#adresse-anzeigen"><span>Adresse anzeigen</span></a></h3>
<p>Springt zu der ausgewählten Haushaltsadresse. Die gewählte Adresse wird in der Adressmaske angezeigt.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.adrdublhaush.html" title="Dubletten">mögliche Dubletten/Haushalte</RouteLink></p>
</div></template>


